import React from 'react'
import { useSelector } from 'react-redux'
import { t } from 'ttag'

import { getRespondent } from 'ducks/respondent'
import { Icon } from 'components/shared/Icon/Icon'
import { AlertTriangleIcon } from 'components/shared/Icon/model'

import { DeadlineHint, MailHint } from '../Quiz/Quiz'
import { WaveContainer } from '../WaveContainer/WaveContainer'

import styles from './DeadlineExpired.module.scss'

const DeadlineExpired = () => {
  const { deadline, deadline_display, deadline_tz, language } =
    useSelector(getRespondent)

  return (
    <WaveContainer>
      <div className={styles.centerContent}>
        <div className={styles.box}>
          <div className={styles.iconWrap} aria-hidden>
            <Icon className={styles.icon} icon={AlertTriangleIcon} size={28} />
          </div>
          <div className={styles.text}>
            <p className={styles.eyebrow}>{t`Deadline passed`}</p>
            <h1 className={styles.title}>
              {t`The assessment window has closed`}
            </h1>
            <p className={styles.body}>
              {t`Unfortunately, you no longer have access to complete these tests. If you would still like to participate, please contact the recruitment manager at the company.`}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.hints}>
        <DeadlineHint
          {...{ deadline, deadline_display, deadline_tz, language }}
          past_deadline
        />
        <MailHint />
      </div>
    </WaveContainer>
  )
}

export default DeadlineExpired
